import NotFoundPage from '@/pages/not-found.page';
import type { ReactNode } from 'react';
import { LazyPage } from './-route-layouts';
import { ActionDevPage, CampaignsDevPage, ConditionViewerDevPage, VercelInstallPreviewDevPage } from './-route-pages';

type DevRouteProps = {
  children: ReactNode;
};

function DevRoute({ children }: DevRouteProps) {
  if (!import.meta.env.DEV) {
    return <NotFoundPage />;
  }

  return <LazyPage>{children}</LazyPage>;
}

export function ConditionViewerDevRoute() {
  return (
    <DevRoute>
      <ConditionViewerDevPage />
    </DevRoute>
  );
}

export function CampaignsDevRoute() {
  return (
    <DevRoute>
      <CampaignsDevPage />
    </DevRoute>
  );
}

export function ActionDevRoute() {
  return (
    <DevRoute>
      <ActionDevPage />
    </DevRoute>
  );
}

export function VercelInstallPreviewDevRoute() {
  return (
    <DevRoute>
      <VercelInstallPreviewDevPage />
    </DevRoute>
  );
}
